import React, { useContext } from 'react';
import Hidden from '@material-ui/core/Hidden';
import { Box, makeStyles } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import CmtImage from '../../../../@coremat/CmtImage';
import AppContext from '@jumbo/components/contextProvider/AppContextProvider/AppContext';
import { getImage } from '@codeArt/electron/renderer/util';
import { type } from '@codeArt/utils/common';


const useStyles = makeStyles(theme => ({
  link: {
    lineHeight: '0'  //修复LOG不垂直居中的问题
  }
}));

const Logo = ({ color, ...props }) => {
  const { project,headerLogo } = useContext(AppContext);

  let lg,sm,logoUrl,logoSymbolUrl,logoName;
  if(headerLogo){
    lg= headerLogo.lg||["auto","auto"];
    sm = headerLogo.sm||["auto","auto"];
    logoUrl=logoSymbolUrl=headerLogo.url;
    logoName = headerLogo.name;
  }
  else{
    const { logo,name } = project;
    lg= logo.lg;
    sm = logo.sm;

    logoUrl = color === 'white' ? lg.white : lg.deep;
    logoSymbolUrl = color === 'white' ?sm.white : sm.deep;
    logoName=name;
  }

  const redirect = project.logo?.redirect || headerLogo?.logo?.redirect;

  const classes = useStyles();

  return (
    <Box className={`pointer ${classes.link}`} {...props}>
      <Hidden xsDown>
        <NavLink to={redirect}>
          <CmtImage src={getImage(logoUrl)} alt={logoName} {...lg.size?{width:lg.size[0],height:lg.size[1]}:null} />
        </NavLink>
      </Hidden>
      <Hidden smUp>
        <NavLink to={redirect}>
          <CmtImage src={getImage(logoSymbolUrl)} alt={logoName} {...sm.size?{width:sm.size[0],height:sm.size[1]}:null} />
        </NavLink>
      </Hidden>
    </Box>
  );
};

export default Logo;
